const DISPLAY_NONE_CLASS = 'hidden';
const FORM_VISIBILITY_CHANGED_EVENT = 'form-visibility-changed';

function forceFormIdIsValid(formSelect, forceForm) {
    return [...formSelect.options].map((option) => option.value)
        .filter((value) => !!value).includes(forceForm);
}

function toggleForms(formSelect, forceFormId = null) {
    const blockId = formSelect.getAttribute('data-block-id');
    let formIdToShow = formSelect.value;
    if (forceFormIdIsValid(formSelect, forceFormId)) {
        formIdToShow = forceFormId;
        // eslint-disable-next-line no-param-reassign
        formSelect.value = formIdToShow;
    }
    const targetedItem = document.querySelector(`[data-sample-request-form-id="${formIdToShow}"][data-block-id="${blockId}"]`);
    document.querySelectorAll(`[data-sample-request-form-id][data-block-id="${blockId}"]`).forEach((element) => {
        element.classList.add(DISPLAY_NONE_CLASS);
    });
    if (!targetedItem) {
        document.dispatchEvent(new CustomEvent(FORM_VISIBILITY_CHANGED_EVENT));
        return;
    }
    document.dispatchEvent(new CustomEvent(FORM_VISIBILITY_CHANGED_EVENT));
    targetedItem.classList.remove(DISPLAY_NONE_CLASS);
}

function bindEvents(formSelect) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlSearchParamForm = urlSearchParams.get('form');
    toggleForms(formSelect, urlSearchParamForm);
    formSelect.addEventListener('change', () => {
        toggleForms(formSelect);
    });
}

export default function initSampleRequestFormSelector() {
    const formSelect = document.querySelectorAll('[data-sample-request-form-choice]');
    formSelect.forEach((element) => {
        bindEvents(element);
    });
}
